import { createContext } from "react";
const ActionsContext = createContext(null);
export {
  ActionsContext
};
